module.exports = __webpack_public_path__ + "static/media/createRole.ab5e268b.svg";